import { render, staticRenderFns } from "./WorkspaceResultSelectDesign.vue?vue&type=template&id=a461b120&scoped=true&"
import script from "./WorkspaceResultSelectDesign.vue?vue&type=script&lang=js&"
export * from "./WorkspaceResultSelectDesign.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceResultSelectDesign.vue?vue&type=style&index=0&id=a461b120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a461b120",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a461b120')) {
      api.createRecord('a461b120', component.options)
    } else {
      api.reload('a461b120', component.options)
    }
    module.hot.accept("./WorkspaceResultSelectDesign.vue?vue&type=template&id=a461b120&scoped=true&", function () {
      api.rerender('a461b120', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceResultSelectDesign.vue"
export default component.exports